import articleList from './article-list-rd';
import article from './article-rd';
import comments from './comments-rd';

export default {
  articleList,
  article,
  comments,
};



// WEBPACK FOOTER //
// src/modules/article/essay/reducers/index.js